// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// // import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries
// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyD-FlVqKGR631maJxRncoaakQpFI4g_mnc",
//   authDomain: "iinvestv1.firebaseapp.com",
//   databaseURL: "https://iinvestv1-default-rtdb.firebaseio.com",
//   projectId: "iinvestv1",
//   storageBucket: "iinvestv1.appspot.com",
//   messagingSenderId: "90564983436",
//   appId: "1:90564983436:web:e425ca6c5a28c99eec19a9",
//   measurementId: "G-9ELL8BK8G0"
// };
// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// // const analytics = getAnalytics(app);
// export default app;
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// below one is for rizwan.345awan@gmail.com
// const firebaseConfig = {
//   apiKey: "AIzaSyCMxkWDoRJnOa_0151MM9KIK_4nk_DJvX4",
//   authDomain: "aofform-6e881.firebaseapp.com",
//   projectId: "aofform-6e881",
//   storageBucket: "aofform-6e881.appspot.com",
//   messagingSenderId: "248396259352",
//   appId: "1:248396259352:web:42e79fbd5b9a6db21c636d",
//   measurementId: "G-10LQSN9PVC"
// };
const firebaseConfig = {
  apiKey: "AIzaSyAFptu-psls1NG3EfkfOr4vp57ScfOuOK4",
  authDomain: "aofform-4de14.firebaseapp.com",
  projectId: "aofform-4de14",
  storageBucket: "aofform-4de14.appspot.com",
  messagingSenderId: "178881353045",
  appId: "1:178881353045:web:d8d70efb36de3d5aa84bdc",
  measurementId: "G-MTPXQK8FQ4"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export default analytics;